"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_85_3_0 = void 0;
/**
 * rename Leitung -> shielding
 * map shielding and twistedPair to new enums
 */
const migration_85_3_0 = (json) => {
    var _a;
    if (json.Kette) {
        migrateKette20toKette21(json.Kette);
        if (json.Kette.AdapterLink) {
            migrateKette20toKette21(json.Kette.AdapterLink);
        }
        if (json.Kette.ModifiedLink) {
            migrateKette20toKette21(json.Kette.ModifiedLink);
        }
        if (json.Kette.AutoglideLink) {
            migrateKette20toKette21(json.Kette.AutoglideLink);
        }
        if (json.Kette.RolLink) {
            migrateKette20toKette21(json.Kette.RolLink);
        }
        if (json.Kette.StandardLink) {
            migrateKette20toKette21(json.Kette.StandardLink);
        }
    }
    if ((_a = json.IAs) === null || _a === void 0 ? void 0 : _a.length) {
        json.IAs.forEach((ia) => {
            if (ia.IAKonfigFreigabe != null) {
                ia.FreigabeEIC = ia.IAKonfigFreigabe;
                delete ia.IAKonfigFreigabe;
            }
        });
    }
    return json;
};
exports.migration_85_3_0 = migration_85_3_0;
const migrateKette20toKette21 = (kette) => {
    if (kette.IAKonfigFreigabe != null) {
        kette.FreigabeEIC = kette.IAKonfigFreigabe;
        kette.FreigabeEKEManualMode = kette.IAKonfigFreigabe;
        delete kette.IAKonfigFreigabe;
    }
    if (kette.LeitungsdurchmesserMin || kette.LeitungsdurchmesserMax) {
        kette.LeitungDiameterMax = kette.LeitungsdurchmesserMin || kette.LeitungsdurchmesserMax;
        delete kette.LeitungsdurchmesserMin;
        delete kette.LeitungsdurchmesserMax;
    }
    if (kette.LeitungsdurchmesserMin_mm || kette.LeitungsdurchmesserMax_mm) {
        kette.LeitungDiameterMax_mm = kette.LeitungsdurchmesserMin_mm || kette.LeitungsdurchmesserMax_mm;
        delete kette.LeitungsdurchmesserMin_mm;
        delete kette.LeitungsdurchmesserMax_mm;
    }
};
//# sourceMappingURL=migration_85_3_0.js.map